import ImageOptions from "%/dynamic-components/render-engine/bundles/image-options";
import SingleImage from "%/dynamic-components/render-engine/options/image-options/single-image";
import {
  StandardImageElementMixin,
} from "%/dynamic-components/render-engine/components/production/elements/image-element/standard-image-element-mixin";
import {
  OptionMediaResolverMixin,
} from "%/dynamic-components/render-engine/mixins/production/option-media-resolver-mixin";

export const SingleImageElementMixin = {
  mixins: [StandardImageElementMixin, OptionMediaResolverMixin],
  optionBundles: [
    ImageOptions,
  ],
  computed: {
    fallbackImageSrc() {
      return "";
    },
    imageMediaUnresolvable() {
      return this.isOptionMediaUnresolvable(this.getOptionValue(SingleImage));
    },
    imageSrc() {
      return this.resolveOptionMedia(this.getOptionValue(SingleImage));
    },
  },
};
